export default __webpack_public_path__ + "static/media/oscer-pres-facial-swelling.22e1902b.svg";